import React from 'react';
import classNames from 'classnames';
import path from 'path';
import api from 'api';
import { PMS_URL } from '../../config';
import { AppLink } from '../modules/routing/containers';

class DashBoardMenu extends React.Component {
  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
    this.isDropdownOpen = this.isDropdownOpen.bind(this);
    this.handleClickDropdown = this.handleClickDropdown.bind(this);
    this.state = {
      dropdowns: {
        quick_actions: false,
      }
    };
  }
  componentWillMount() {
    this.props.api.dashboard.getDashboardMenuData();
  }
  componentDidMount() {
    this.openDropdownFor(this.props.location.pathname);
    this.menuDataTimer = setInterval(() => {
      this.props.api.dashboard.getDashboardMenuData();
    }, 15000);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.openDropdownFor(nextProps.location.pathname);
    }
  }
  componentWillUnmount() {
    clearInterval(this.menuDataTimer);
  }
  render() {
    const {
      nbNewMessages, nbMessagesToProcess, nbNewInquiriesNotification,
      nbPendingInquiries, nbArrivalsToday, nbDeparturesToday,
      nbRecentPrereservations, nbEarlierPrereservations, nbReservationsToConfirm, nbReservationsToPrint,
      nbReservationsWithError,
    } = this.props;
    const root = '/dashboard';
    return (
      <ul className="sidebar-menu">
        <li className={ classNames({ active: this.isActive('/email/messages?filter=toProcess&folder=inbox') }) }>
          <AppLink to="/email/messages?filter=toProcess&folder=inbox" customRoot={ root }>
            <i className="fas fa-envelope fa-fw"></i> <span>Messages</span>
            <span className="pull-right-container">
              { this.renderInfoNb(nbMessagesToProcess, 'bg-yellow') }
              { this.renderInfoNb(nbNewMessages, 'bg-green') }
            </span>
          </AppLink>
        </li>
        <li className={ classNames({ active: this.isActive('/email/messages?filter=toProcess&folder=notifications') }) }>
          <AppLink to="/email/messages?filter=toProcess&folder=notifications" customRoot={ root }>
            <i className="fas fa-info-circle fa-fw"></i> <span>Inquiry notifications</span>
            <span className="pull-right-container">
              { this.renderInfoNb(nbNewInquiriesNotification, 'bg-green') }
            </span>
          </AppLink>
        </li>
        {/*
        <li className={ classNames({ active: this.isActive('/daily-rental/inquiries?filter=new') }) }>
          <AppLink to="/daily-rental/inquiries?filter=pending" customRoot={ root }>
            <i className="fas fa-question-circle fa-fw"></i> <span>Inquiries</span>
            <span className="pull-right-container">
              { this.renderInfoNb(nbPendingInquiries, 'bg-green') }
            </span>
          </AppLink>
        </li>
        */}
        <li className={ classNames({ active: this.isActive('/daily-rental/reservations?filter=recent_prereservations') }) }>
          <AppLink to="/daily-rental/reservations?filter=recent_prereservations" customRoot={ root }>
            <i className="fas fa-calendar fa-fw"></i> <span>Pre-reservations</span>
            <span className="pull-right-container">
              { this.renderInfoNb(nbEarlierPrereservations, 'bg-yellow') }
              { this.renderInfoNb(nbRecentPrereservations, 'bg-green') }
            </span>
          </AppLink>
        </li>
        <li className={ classNames({ active: this.isActive('/daily-rental/reservations?filter=to_validate') }) }>
          <AppLink to="/daily-rental/reservations?filter=to_validate" customRoot={ root }>
            <i className="fas fa-calendar-check fa-fw"></i> <span>Reservations to confirm</span>
            <span className="pull-right-container">
              { this.renderInfoNb(nbReservationsToConfirm, 'bg-orange') }
            </span>
          </AppLink>
        </li>
        <li className={ classNames({ active: this.isActive('/daily-rental/reservations?filter=not_printed') }) }>
          <AppLink to="/daily-rental/reservations?filter=not_printed" customRoot={ root }>
            <i className="fas fa-print fa-fw"></i> <span>Confirmations to print</span>
            <span className="pull-right-container">
              { this.renderInfoNb(nbReservationsToPrint) }
            </span>
          </AppLink>
        </li>
        {
          nbReservationsWithError && nbReservationsWithError > 0
            ? <li className={ classNames({ active: this.isActive('/daily-rental/reservations?filter=error') }) }>
                <AppLink to="/daily-rental/reservations?filter=error" customRoot={ root }>
                  <span>Reservations with error</span>
                  <span className="pull-right-container">
                    { this.renderInfoNb(nbReservationsWithError, 'bg-red') }
                  </span>
                </AppLink>
              </li>
            : null
        }
        <li className={ classNames({ active: this.isActive('/daily-rental/arrivals-departures') }) }>
          <AppLink to="/daily-rental/arrivals-departures" customRoot={ root }>
            <i className="fas fa-exchange-alt fa-fw"></i> <span>Arrivals/Departures</span>
            <span className="pull-right-container">
              { this.renderInfoNb(nbDeparturesToday, 'bg-purple') }
              { this.renderInfoNb(nbArrivalsToday, 'bg-blue') }
            </span>
          </AppLink>
        </li>
        <li className={ classNames({ active: this.isActive('/overview') }) }>
          <AppLink to="/overview" customRoot={ root }>
            <i className="fas fa-chart-bar fa-fw"></i> <span>Overview</span>
          </AppLink>
        </li>
        <li className={ classNames('treeview', { active: this.isDropdownOpen('quick_actions') }) }>
          <a href="#" onClick={ this.handleClickDropdown.bind(null, 'quick_actions') }>
            <i className="fas fa-share fa-fw"></i> <span>Quick Actions</span><i className="fas fa-angle-left pull-right"></i>
          </a>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/daily-rental/inquiries/new') }) }>
              <AppLink to="/daily-rental/inquiries/new" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Create new inquiry</span></AppLink>
            </li>
          </ul>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/daily-rental/reservations/new') }) }>
              <AppLink to="/daily-rental/reservations/new" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Create new reservation</span></AppLink>
            </li>
          </ul>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/daily-rental/availabilities/search') }) }>
              <AppLink to="/daily-rental/availabilities/search" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Search availabilities</span></AppLink>
            </li>
          </ul>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/daily-rental/availabilities/calendar') }) }>
              <AppLink to="/daily-rental/availabilities/calendar" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Show global calendar</span></AppLink>
            </li>
          </ul>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/daily-rental/ibe-calendar') }) }>
              <AppLink to="/daily-rental/ibe-calendar" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Show IBE calendar</span></AppLink>
            </li>
          </ul>
        </li>
      </ul>
    );
  }

  renderInfoNb(value, className='bg-light-blue') {
    // if (!value || value === 0) {
    //   return <span className="label label-primary pull-right">{ value }</span>;
    // }
    return <span className={"label pull-right " + className}>{ value }</span>;
  }

  isActive(url) {
    const [pathname, searchParams] = url.split('?');
    return this.props.location.pathname.match(`^${this.resolveUrl(pathname)}`)
      && this.props.location.search.match(searchParams);
  }
  isDropdownOpen(name) {
    return this.state.dropdowns[name];
  }
  openDropdownFor(url) {
    let name;
    if (this.isDropdownQuickActionsOpen(url)) name = 'quick_actions';
    const dropdowns = Object.keys(this.state.dropdowns).reduce((object, _name) => ({ ...object, [_name]: false }), {});
    if (name) dropdowns[name] = true;
    this.setState({ dropdowns });
  }
  isDropdownQuickActionsOpen(url) {
    return [
      '/daily-rental/inquiries/new',
      '/daily-rental/reservations/new',
      '/daily-rental/availabilities/search',
      '/daily-rental/availabilities/calendar',
      '/daily-rental/ibe-calendar',
    ].find(pathname => {
      return url.match(`^${this.resolveUrl(pathname)}`);
    });
  }
  handleClickDropdown(name, evt = null) {
    if (evt) { evt.preventDefault(); }
    const dropdowns = { ...this.state.dropdowns };
    Object.keys(dropdowns)
      .filter(n => n !== name)
      .map(n => dropdowns[n] = false);
    dropdowns[name] = !dropdowns[name];
    this.setState({ dropdowns });
  }
  resolveUrl(url) {
    const currentUrl = path.join('/dashboard', url);
    return PMS_URL === '/' ? currentUrl : `${PMS_URL}${currentUrl}`;
  }
}

DashBoardMenu.propTypes = {
  api: React.PropTypes.object,
  location: React.PropTypes.object,
};

export default api.connect(DashBoardMenu, 'dashboard', { noClearOnUnmount: true });



// WEBPACK FOOTER //
// ./src/frontend/layout/DashboardMenu.jsx